module.exports = __webpack_public_path__ + "static/media/VIDEO-SPRAY.841d3aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/VIDEO-SPRAY.png
// module id = 292
// module chunks = 0